import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const Game5On5Services = {
  get5On5GameVideos,
  addUpdate5On5Game,
  delete5On5Game,
};

async function get5On5GameVideos(eventId, playerId, gameVideosId) {
  const params = new URLSearchParams();

  if (eventId) params.append("EventId", eventId);
  if (gameVideosId) params.append("GameVideosId", gameVideosId);
  if (playerId) params.append("PlayerId", playerId);

  const url = `${APIURLConstants.GET_5ON5_GAME_VIDEOS}?${params.toString()}`;

  const response = await APIHelper.get(url, authHeader());
  return response;
}

async function addUpdate5On5Game(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.ADD_UPDATE_5ON5_GAME}`,
    formObj,
    authHeader()
  );
  return response;
}

async function delete5On5Game(gameVideosId, ProcessedBy) {
  const response = await APIHelper.post(
    `${APIURLConstants.DELETE_5ON5_GAME}?GameVideosId=${gameVideosId}&ProcessedBy=${ProcessedBy}`,
    authHeader()
  );
  return response;
}
